export class PartnerHelper {
  public static isPartnerChangeRequest(partnerId: string): boolean {
    return partnerId.startsWith('new-')
  }

  public static isPortalPartnerRequest(partnerId: string): boolean {
    return partnerId.startsWith('portal-')
  }

  public static isDummyPartnerRequest(partnerId: string): boolean {
    return (
      PartnerHelper.isPartnerChangeRequest(partnerId) ||
      PartnerHelper.isPortalPartnerRequest(partnerId)
    )
  }
}
